import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinner = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#paint0_angular_2419_13_clip_path)",
			"data-figma-skip-parse": "true",
			children: /* @__PURE__ */ _jsx("g", {
				transform: "matrix(0 0.01 -0.01 0 10 10)",
				children: /* @__PURE__ */ _jsx("foreignObject", {
					x: -1100,
					y: -1100,
					width: 2200,
					height: 2200,
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							background: "conic-gradient(from 90deg,rgba(98, 99, 108, 1) 0deg,rgba(98, 99, 108, 0) 360deg)",
							height: "100%",
							width: "100%",
							opacity: 1
						}
					})
				})
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM3.32319 10C3.32319 13.6875 6.3125 16.6768 10 16.6768C13.6875 16.6768 16.6768 13.6875 16.6768 10C16.6768 6.3125 13.6875 3.32319 10 3.32319C6.3125 3.32319 3.32319 6.3125 3.32319 10Z",
			"data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.38431373238563538,\"g\":0.38823530077934265,\"b\":0.42352941632270813,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.38431373238563538,\"g\":0.38823530077934265,\"b\":0.42352941632270813,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.38431373238563538,\"g\":0.38823530077934265,\"b\":0.42352941632270813,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.38431373238563538,\"g\":0.38823530077934265,\"b\":0.42352941632270813,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":1.2246467996456087e-15,\"m01\":-20.0,\"m02\":20.0,\"m10\":20.0,\"m11\":1.2246467996456087e-15,\"m12\":-1.2246467996456087e-15},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9.99998,
			cy: 18.3333,
			r: 1.66667,
			fill: "#62636C"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "paint0_angular_2419_13_clip_path",
			children: /* @__PURE__ */ _jsx("path", { d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM3.32319 10C3.32319 13.6875 6.3125 16.6768 10 16.6768C13.6875 16.6768 16.6768 13.6875 16.6768 10C16.6768 6.3125 13.6875 3.32319 10 3.32319C6.3125 3.32319 3.32319 6.3125 3.32319 10Z" })
		}) })
	]
});
export default SvgSpinner;
